module.exports = __webpack_public_path__ + "img/slack-archived-channel.5689d306.svg";